/**
 * Google's encoded polyline (precision 5), which InGo's road engine answers
 * with (`POST routes`, a tracking estimate), decoded to the `[lng, lat]`
 * pairs MapLibre draws. Copied from the console's `src/maps/polyline.ts`
 * with its tests; the algorithm is Google's published one. A malformed
 * string decodes to what it held before the fault.
 *
 * @param {string} encoded
 * @param {number} [precision]
 * @returns {Array<[number, number]>}
 */
export function decodePolyline(encoded, precision = 5) {
  const factor = 10 ** precision;
  const points = [];
  const text = String(encoded || '');
  let index = 0;
  let lat = 0;
  let lng = 0;

  const next = () => {
    let result = 0;
    let shift = 0;
    let byte;

    do {
      if (index >= text.length) return null;
      byte = text.charCodeAt(index++) - 63;
      result |= (byte & 0x1f) << shift;
      shift += 5;
    } while (byte >= 0x20);

    return result & 1 ? ~(result >> 1) : result >> 1;
  };

  while (index < text.length) {
    const dLat = next();
    const dLng = next();
    if (dLat === null || dLng === null) break;
    lat += dLat;
    lng += dLng;
    points.push([lng / factor, lat / factor]);
  }

  return points;
}
